
import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../Logo';

const FooterInfo: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <Logo size="sm" />
        <p className="mt-4 text-muted-foreground max-w-md">
          Calculator provides beautifully designed calculators for finance, health, and everyday calculations.
        </p>
      
        <div className="mt-6">
          <h4 className="font-semibold text-foreground mb-4">Resources</h4>
          <ul className="space-y-2">
            <li>
              <Link to="/privacy-policy" className="text-muted-foreground hover:text-primary">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/terms-of-use" className="text-muted-foreground hover:text-primary">
                Terms of Use
              </Link>
            </li>
            <li>
              <Link to="/sitemap" className="text-muted-foreground hover:text-primary">
                Sitemap
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default FooterInfo;
